var React = require('react');

function Logout12x12 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=12x12, Invert=On, Active=Log out","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"id":"Vector","d":"M8 9l3-2.5v-1L8 3","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M4 6h7","strokeLinejoin":"bevel","key":1}),React.createElement("path",{"id":"Vector 234","d":"M6 1H2a1 1 0 00-1 1v8a1 1 0 001 1h4","key":2})]));
}

Logout12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Logout12x12;

Logout12x12.default = Logout12x12;
